import React from 'react'
import './style.css'

const TagList = ({ items, className = '' }) => {
    if (!items || items.length === 0) return null

    return (
        <div className={`tag-list ${className}`}>
            {items.map((item, index) => (
                <span key={index} className="tag-item">{item}</span>
            ))}
        </div>
    )
}

export default TagList

